import React from "react";
import {
  Query,
  Create,
  NumberInput,
  LongTextInput, TextInput,
  SaveButton,
  DeleteButton,
  AutocompleteInput,
  TextField,
  ReferenceField,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  ReferenceInput,
  DateInput,
  BooleanInput,
  DisabledInput
} from "react-admin";

import styled from "styled-components";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { parse } from "query-string";
import { FormDataConsumer } from "react-admin";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import { isNil, isEmpty } from "ramda";
import { getPermissionRole } from "../util";

const StyledAutocompleteInput = styled(AutocompleteInput)`
  width: 340px !important;
`;
const styles = {
  vhicleTypeId: { display: "none" }
};

const VehicleTypeId = withStyles(styles)(({ classes, ...props }) => {
  return (
    <DisabledInput
      source="vehicle_type_id"
      className={classes.vhicleTypeId}
      defaultValue={props.defaultValue}
    />
  );
});

const MaintenanceTitle = object => (
  <span>
    {" Edit Maintenance entry "} {object.record.id}
  </span>
);

const MaintenanceCreateTitle = record => (
  <span>Create Maintenance Item Type entry</span>
);

const CancelButton = _props => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `${_props.redirectTo}`
      }}
      label="Cancel"
    >
      <ArrowBackIcon />
    </Button>
  );
};

const MaintenanceCreateToolbar = props => {
  return (
    <Toolbar {...props}>
      {([1, 2, 5, 6, 7, 9].includes(getPermissionRole()) && 
        <SaveButton redirect={`/vehicles/${props.record.vehicle_id}/3`} />
      )}
      <CancelButton redirectTo={props.redirect} />
    </Toolbar>
  );
};

const MaintenanceToolbar = props => {
  return (
    <Toolbar {...props}>
       {([1, 2, 5, 6, 7, 9].includes(getPermissionRole()) && 
        <React.Fragment>
          <SaveButton {...props} redirect={`/vehicles/${props.record.vehicle_id}/3`} />
          <DeleteButton
            record={props.record}
            resource={props.resource}
            redirect={`/vehicles/${props.record.vehicle_id}/3`}
          />              
        </React.Fragment>
      )}
      <CancelButton redirectTo={`/vehicles/${props.record.vehicle_id}/3`} />
    </Toolbar>
  );
};

const validateForm = values => {
  const errors = {};
  if (!values.location_id) {
    errors.location_id = ["Location is required"];
  }
  if (!values.maintenance_item_id) {
    errors.maintenance_item_id = ["Maintenance item is required"];
  }
  if (!values.maintenance_date) {
    errors.maintenance_date = ["Maintenance date is required"];
  }
  if (values.maintenance_date) {
    const maintDate = moment(values.maintenance_date).format("YYYY-MM-DD");
    const nowDate = moment(Date.now()).format("YYYY-MM-DD");
    if (moment(maintDate).diff(moment(nowDate), "days") > 0) {
      errors.maintenance_date = [
        "Maintenance Date should be earlier or equal than current date"
      ];
    }
  }
  return errors;
};

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const MaintenanceEdit = props => {
  const vehicle_id = parse(props.location.search).vehicle_id;
  const redirect = vehicle_id ? `/vehicles/${vehicle_id}/3` : "edit";

  return (
    <Edit title={<MaintenanceTitle />} {...props}>
      <SimpleForm
        redirect={redirect}
        toolbar={<MaintenanceToolbar />}
        validate={validateForm}
      >
        <ReferenceField
          label="Vehicle"
          source="vehicle_id"
          reference="vehicles"
        >
          <TextField source="licence_plate" />
        </ReferenceField>

        <ReferenceInput
          label="Location"
          source="location_id"
          reference="locations"
          filter={{ only_bases: "false" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <StyledAutocompleteInput
            optionText={location => `${location.location_name}`}
          />
        </ReferenceInput>
        <ReferenceInput
          label="Agent"
          source="agent_id"
          reference="agents"
          sort={{ field: "agent", order: "ASC" }}
        >
          <StyledAutocompleteInput optionText={agent => `${agent.agent}`} />
        </ReferenceInput>

        <FormDataConsumer>
          {({ formData, ...rest }) => {
            if (isNil(formData) || isEmpty(formData)) {
              return "";
            }
            return (
              <React.Fragment>
                <Query
                  type="GET_ONE"
                  resource="maintenance_items"
                  payload={{ id: formData.maintenance_item_id }}
                >
                  {({ data, loading }) => {
                    return loading ? (
                      ""
                    ) : (
                      <ReferenceInput
                        label="Maintenance Item"
                        source="maintenance_item_id"
                        reference="maintenance_items"
                        perPage={1000}
                        sort={{ field: "description", order: "ASC" }}
                        filter={{
                          show_max: "true",
                          maintenance_item_type_id:
                            data.maintenance_item_type_id,
                          vehicle_type: formData.vehicle_type_id
                        }}
                      >
                        <StyledAutocompleteInput
                          optionText={maintenanceItem =>
                            `${maintenanceItem.description} ${maintenanceItem.maintenance_item_type &&
                              !maintenanceItem.description.includes("Periodic")
                              ? " - " +
                              maintenanceItem.maintenance_item_type
                                .description
                              : ""
                            } - ${maintenanceItem.rev_kms} kms`
                          }
                        />
                      </ReferenceInput>
                    );
                  }}
                </Query>

                {!isNil(formData.vehicle_id) && (
                  <VehicleData vehicleId={formData.vehicle_id} />
                )}
              </React.Fragment>
            );
          }}
        </FormDataConsumer>
        <NumberInput source="total_price" />
        <DateInput label="Maintenance date" source="maintenance_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
        <TextInput source="invoice_number" />
        <NumberInput source="maintenance_kms" />
        <BooleanInput label="Maintenance Done" source="done" />

        <LongTextInput
          source="notes"
          label="Notes"
          style={{ minHeigth: "70px" }}
        />
      </SimpleForm>
    </Edit>
  );
};

const VehicleData = ({ vehicleId }) => {
  return (
    <Query type="GET_ONE" resource="vehicles" payload={{ id: vehicleId }}>
      {({ data, loading }) =>
        loading ? (
          ""
        ) : (
          <VehicleTypeId defaultValue={data.model.vehicle_type_id} />
        )
      }
    </Query>
  );
};

export const MaintenanceCreate = props => {
  const vehicle_id = parse(props.location.search).vehicle_id;
  const redirect = vehicle_id ? `/vehicles/${vehicle_id}/3` : "edit";
  return (
    <Create title={<MaintenanceCreateTitle />} {...props}>
      <SimpleForm
        redirect={redirect}
        toolbar={<MaintenanceCreateToolbar props={{ ...props }} />}
        validate={validateForm}
      >
        <VehicleData vehicleId={vehicle_id} />
        <ReferenceField
          label="Vehicle"
          source="vehicle_id"
          reference="vehicles"
        >
          <TextField source="licence_plate" />
        </ReferenceField>

        <ReferenceInput
          label="Location"
          source="location_id"
          reference="locations"
          filter={{ only_bases: "false" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <StyledAutocompleteInput
            optionText={location => `${location.location_name}`}
          />
        </ReferenceInput>

        <ReferenceInput
          label="Agent"
          source="agent_id"
          reference="agents"
          sort={{ field: "agent", order: "ASC" }}
        >
          <StyledAutocompleteInput optionText={agent => `${agent.agent}`} />
        </ReferenceInput>

        <FormDataConsumer>
          {({ formData, ...rest }) => {
            return (
              <React.Fragment>
                <ReferenceInput
                  label="Maintenance Item Type"
                  source="maintenance_item_type_id"
                  reference="maintenance_item_types"
                  perPage={1000}
                  sort={{ field: "description", order: "ASC" }}
                  filter={{
                    show_max: "true",
                    vehicle_type: formData.vehicle_type_id
                  }}
                >
                  <StyledAutocompleteInput
                    optionText={itemType => `${itemType.description}`}
                  />
                </ReferenceInput>

                <ReferenceInput
                  style={{ width: "100%" }}
                  label="Maintenance Item"
                  source="maintenance_item_id"
                  reference="maintenance_items"
                  perPage={1000}
                  sort={{ field: "description", order: "ASC" }}
                  filter={{
                    show_max: "true",
                    vehicle_type: formData.vehicle_type_id,
                    maintenance_item_type_id: formData.maintenance_item_type_id
                  }}
                >
                  <StyledAutocompleteInput
                    optionText={maintenanceItem =>
                      `${maintenanceItem.description} ${maintenanceItem.maintenance_item_type &&
                        !maintenanceItem.description.includes("Periodic")
                        ? " - " +
                        maintenanceItem.maintenance_item_type.description
                        : ""
                      } ${maintenanceItem.rev_kms > 0
                        ? ` - ${maintenanceItem.rev_kms} kms`
                        : ""
                      } `
                    }
                  />
                </ReferenceInput>
              </React.Fragment>
            );
          }}
        </FormDataConsumer>

        {/* <FormDataConsumer>
          {({ formData, ...rest }) => (
            <AsyncComponent formData={formData} rest={rest} />
          )}
        </FormDataConsumer> */}

        <DateInput label="Maintenance date" source="maintenance_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
        <NumberInput label="Total Price" source="total_price" />
        <TextInput source="invoice_number" />
        <NumberInput source="maintenance_kms" />
        <LongTextInput source="notes" label="Notes" />
      </SimpleForm>
    </Create>
  );
};



// WEBPACK FOOTER //
// ./src/resources/maintenances.js